import { jsx as _jsx } from "react/jsx-runtime";
import { OGPortConfiguredIcon } from '@opengear/icons/ports/port-configured';
import { useTranslation } from 'react-i18next';
import { OGPortUnconfiguredIcon } from '@opengear/icons/ports/port-unconfigured';
export function PortStateCell(_a) {
    var port = _a.port;
    var t = useTranslation().t;
    return port.mode === 'consoleServer' ? (_jsx(OGPortConfiguredIcon, { fontSize: "medium", sx: { height: 21, marginLeft: 1 }, titleAccess: t('global.ports.configured') })) : (_jsx(OGPortUnconfiguredIcon, { fontSize: "medium", sx: { height: 21, marginLeft: 1 }, titleAccess: t('global.ports.unconfigured') }));
}
